import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cef9e166"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner" }

import {
  ServiceStatusKeyBlock,
  ServiceStatusHome,
} from '@components';
import { useServiceStatusStore } from '@components/stores';
import process from 'process';
import { onMounted, ref } from 'vue';
import ModalOverlay from './ModalOverlay.vue';
import { useSharedState } from '../helpers/shareState';
import { closeOverlay } from '../helpers/closeOverlayPanel';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceStatusIndex',
  setup(__props) {

const serviceStatusStore = useServiceStatusStore();
const showServiceStatusModal = ref(false);

const statusMapUrl = process.env.VUE_APP_SERVICE_STATUS_MAP_URL;
const statusUrl = process.env.VUE_APP_SERVICE_STATUS_URL;

const sharedState = useSharedState();
sharedState.getState('routeStore');

const removeOverlayOnPage = () => {
  // close overlay after redirecting
  const serviceStatusBtn = document.getElementById('globalLiveServiceStatusButton');
  const serviceStatusBtnMobile = document.getElementById('globalLiveServiceStatusButtonMobile');
  const serviceStatusOverlay = document.getElementById('liveServiceStatusAppOverlay');

  if (serviceStatusOverlay) {
    closeOverlay(serviceStatusOverlay);
  }

  if (serviceStatusBtn) {
    closeOverlay(serviceStatusBtn);
  }

  if (serviceStatusBtnMobile) {
    closeOverlay(serviceStatusBtnMobile);
  }

  const body = document.querySelector('body');
  const html = document.querySelector('html');

  // remove overlay and stop scroll from body and html
  if (body && body.classList.contains('darkOverlay')) {
    body.classList.remove('darkOverlay');
  }

  if (html && html.classList.contains('stopScroll')) {
    html.classList.remove('stopScroll');
  }
};

const redirectToServicePage = (route: string) => {
  window.location.href = route;
  removeOverlayOnPage();
};

const routeToRouteItem = (routeCode) => {
  const url = `${process.env.VUE_APP_SERVICE_STATUS_ITEM_URL}/${routeCode}`;
  window.location.href = url;

  removeOverlayOnPage();
};

const displayModal = () => {
  showServiceStatusModal.value = true;
};

const closeModal = () => {
  showServiceStatusModal.value = false;
};

onMounted(async () => {
  // Start up
  await serviceStatusStore.getServiceStatus();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["serviceStatusOverlay", {modalOpen: showServiceStatusModal.value}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('live ferry status')), 1),
      _createVNode(_unref(ServiceStatusHome), {
        "is-overlay-view": true,
        "status-modal-click-handler": () => displayModal(),
        "select-route-map-callback": () => redirectToServicePage(_unref(statusMapUrl)),
        "redirect-to-service-index": () => redirectToServicePage(_unref(statusUrl)),
        "search-input-id": "overlaySearchRoutesInput",
        "search-input-label": "overlaySearchRoutesLabel",
        onGetSelectedRouteCode: _cache[0] || (_cache[0] = (routeCode) => routeToRouteItem(routeCode))
      }, null, 8, ["status-modal-click-handler", "select-route-map-callback", "redirect-to-service-index"])
    ]),
    _createVNode(ModalOverlay, {
      "is-open": showServiceStatusModal.value,
      "show-close-btn": true,
      "close-callback": () => closeModal()
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ServiceStatusKeyBlock), {
          title: _ctx.$t('Key')
        }, null, 8, ["title"])
      ]),
      _: 1
    }, 8, ["is-open", "close-callback"])
  ], 2))
}
}

})